import { type CSSProperties } from 'react';

import { cn } from '@crm/shared/lib';



const isHexColor = (color: string) => color.startsWith('#');

export const getColorDotProps = (color: string) => ({
    className: cn(!isHexColor(color) && color, 'size-2 rounded-full'),
    style: isHexColor(color) ? ({ backgroundColor: color } satisfies CSSProperties) : undefined,
});